<template>
    <a-row>
          <g-master name="fmo_items_taxes"
                    :endpoint="master.endpoint"
                    :tableSetup="master.tableSetup"
                    :parentData="itparentData"
                    :modalFieldsSetup="master.modalFieldsSetup"
                    modalWidth="90%"
          >
            <template slot="masterModal" slot-scope="{record}">
              <a-row :gutter="[8,8]">
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" label="Ica">
                    <a-input-number
                      style="width: 100%" step="1"
                      :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                      :parser="value => value.replace(/\$\s?|(,*)/g, '')"
                      v-decorator="['ica', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" label="Iva">
                    <a-input-number
                      style="width: 100%" step="1"
                      :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                      :parser="value => value.replace(/\$\s?|(,*)/g, '')"
                      v-decorator="['iva', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" label="Cta Contable Ica">
                    <a-input-number
                      style="width: 100%" step="1"
                      :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                      :parser="value => value.replace(/\$\s?|(,*)/g, '')"
                      v-decorator="['n1_ica', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" label="Cta Contable Iva">
                    <a-input-number
                      style="width: 100%" step="1"
                      :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                      :parser="value => value.replace(/\$\s?|(,*)/g, '')"
                      v-decorator="['n1_iva', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" label="Cta Contable Retefuente">
                    <a-input-number
                      style="width: 100%" step="1"
                      :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                      :parser="value => value.replace(/\$\s?|(,*)/g, '')"
                      v-decorator="['n1_rtefuente', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" label="Cta Contable Reteiva">
                    <a-input-number
                      style="width: 100%" step="1"
                      :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                      :parser="value => value.replace(/\$\s?|(,*)/g, '')"
                      v-decorator="['n1_rteiva', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" label="Retefuente">
                    <a-input-number
                      style="width: 100%" step="1"
                      :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                      :parser="value => value.replace(/\$\s?|(,*)/g, '')"
                      v-decorator="['rtefuente', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" label="Reteiva">
                    <a-input-number
                      style="width: 100%" step="1"
                      :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                      :parser="value => value.replace(/\$\s?|(,*)/g, '')"
                      v-decorator="['rteiva', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
              </a-row>
            </template>
          </g-master>
    </a-row>
</template>

<script>
  export default {
    data () {
      return {
        colOptions: {xs: 24, sm: 12},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        },
        master: {
          endpoint: 'fmo_items_taxes',
          tableSetup: {
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'Ica', dataIndex: 'ica', sorter: true},
              {title: 'Iva', dataIndex: 'iva', sorter: true},
              {title: 'Cta Contable Ica', dataIndex: 'n1_ica', sorter: true},
              {title: 'Cta Contable Iva', dataIndex: 'n1_iva', sorter: true},
              {title: 'Cta Contable Retefuente', dataIndex: 'n1_rtefuente', sorter: true},
              {title: 'Cta Contable Reteiva', dataIndex: 'n1_rteiva', sorter: true},
              {title: 'Retefuente', dataIndex: 'rtefuente', sorter: true},
              {title: 'Reteiva', dataIndex: 'rteiva', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'ica'},
            {name: 'iva'},
            {name: 'n1_ica'},
            {name: 'n1_iva'},
            {name: 'n1_rtefuente'},
            {name: 'n1_rteiva'},
            {name: 'rtefuente'},
            {name: 'rteiva'}
          ]
        }
      }
    },
    props: ['id_invoice_item'],
    computed: {
      itparentData () {
        return {
          id_invoice_item: this.id_invoice_item
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/Fmo/ItemsTaxes.vue